import React from 'react'

const IconPlus = ({
  width = 37,
  height = 37,
  color = 'currentColor',
  responsive = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 39"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={color} 
      stroke-width="1"
      width={width}
      height={height}
      {...svgAttributes}
    >
      <g>
        <path d="M18.5,1.25c9.51,0,17.25,7.74,17.25,17.25S28.01,35.75,18.5,35.75S1.25,28.01,1.25,18.5S8.99,1.25,18.5,1.25 M18.5,0.25
          C8.42,0.25,0.25,8.42,0.25,18.5S8.42,36.75,18.5,36.75s18.25-8.17,18.25-18.25S28.58,0.25,18.5,0.25L18.5,0.25z"/>
      </g>
      <g>
        <g transform="translate(-1356, -2171)">
          <g transform="translate(1346, 2162)">
            <polygon fill={color} points="29,19.75 29,27 36.25,27 36.25,28 29,28 29,35.25 28,35.25 
              28,28 20.75,28 20.75,27 28,27 28,19.75"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IconPlus
